<div class="image-container">
  <ng-content></ng-content>
</div>

<h1 mat-dialog-title>{{ title }}</h1>
<p>{{ subtitle }}</p>
